import React from "react";

interface MaatraLogoProps {
  size?: number;
  fill?: string;
}

const MaatraLogo: React.FC<MaatraLogoProps> = ({
  size = 12,
  fill = "#FBFBFB",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M10.7382 6.83282L8.3099 3.46657L8.24601 3.37778C8.07125 3.1356 7.70999 3.13413 7.53376 3.37631L7.46988 3.46437L7.47134 3.46584L6.34275 5.0231L6.76129 5.60359L7.88989 4.04633L10.1867 7.22984C10.5678 7.75822 10.4474 8.49796 9.91798 8.87884L9.80343 8.96103C9.27401 9.34191 8.53312 9.22155 8.15203 8.69317L7.03151 7.13957L4.76404 3.99716L4.37854 3.46217L4.31539 3.37484C4.1399 3.13193 3.77789 3.1312 3.6024 3.37484L3.53925 3.46217L1.10363 6.82254C0.500785 7.65475 0.687293 8.81793 1.52144 9.42043L1.63599 9.50336C2.4694 10.1059 3.63471 9.91873 4.23756 9.08652L5.50126 7.34286L5.08272 6.76237L3.68684 8.68877C3.30355 9.21715 2.56412 9.33604 2.0347 8.95369L1.92016 8.87077C1.39074 8.48842 1.27252 7.75015 1.65508 7.22177L3.95853 4.04266L5.50273 6.18261L5.92127 6.7631L7.59984 9.09019C8.20049 9.9224 9.36727 10.1117 10.2007 9.51216L10.3152 9.42997C10.4812 9.31035 10.6214 9.16872 10.7352 9.0124C11.1934 8.38054 11.2191 7.4999 10.7382 6.83355V6.83282Z"
        fill={fill}
      />
      <path
        d="M5.91485 3.6605C6.5118 3.6605 6.99572 3.17686 6.99572 2.58025C6.99572 1.98364 6.5118 1.5 5.91485 1.5C5.3179 1.5 4.83398 1.98364 4.83398 2.58025C4.83398 3.17686 5.3179 3.6605 5.91485 3.6605Z"
        fill={fill}
      />
    </svg>
  );
};

export default MaatraLogo;
